const context = (require as any).context("!!raw-loader!./changelog", false, /\.md$/);

export const CHANGELOGS: Record<string, string> = {};

context.keys().forEach((key: string) => {
  const version = key.match(/(\d+\.\d+\.\d+)\.md$/)?.[1];
  if (!version) return;

  // CRA returns the raw file content as default export string
  const content = context(key).default;
  CHANGELOGS[version] = content;
});
